export default { 

}



// WEBPACK FOOTER //
// ./src/store/modules/creditos/getters.js